export const ASPECT_RATIOS = {
  SQUARE: "1/1",
  LANDSCAPE: "9/16",
  PORTRAIT: "91/64",
  INFINITY_CAROUSEL: "7/16",
} as const;

export type AspectRatio = typeof ASPECT_RATIOS[keyof typeof ASPECT_RATIOS];
export type AspectRatiosType = keyof typeof ASPECT_RATIOS;

export const HEIGHT_RATIOS = {
  SQUARE: 1 / 1,
  LANDSCAPE: 9 / 16,
  PORTRAIT: 91 / 64,
} as const;
